import { FormFieldsTable } from "./FormFieldsTable";
import QuerySection from "./QuerySection";
import { SelectForm } from "./SelectForm";
import { DescribeMonitorRadioGroupValues } from "@avenueops/shared-types";
import { SmartForm, Button } from "@avenueops/web-components";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { useFormContext } from "react-hook-form";
import { pagesPath } from "utils/$path";

export function SelectFormSection(): JSX.Element {
  const { watch } = useFormContext();
  const formTemplateId = watch("formTemplateId");

  return (
    <div className="flex flex-col gap-8 pb-20">
      <div className="flex-col flex gap-8">
        <SelectForm />
        <div className="w-full flex flex-col gap-1">
          <FormFieldsTable />
          {formTemplateId ? (
            <div className="w-fit self-end">
              <Button TailIcon={ArrowTopRightOnSquareIcon} type="TEXT" size="SMALL">
                <Link href={pagesPath.forms.builder._id(formTemplateId).$url()}>View form</Link>
              </Button>
            </div>
          ) : null}
        </div>
        <div className="text-sm text-gray-700 bg-gray-50 rounded p-4 flex flex-col">
          <div className="block font-medium">
            💡 You can fill out form monitors on Slack by typing
            <code className="text-gray-950"> /avenue </code>
            in a channel that has integrated with the Avenue bot.
          </div>
          <span className="pt-4">Don't want to submit this form on Slack?</span>
          <SmartForm.Toggle name="hideInSlack" title="Hide in Slack" />
        </div>
      </div>
    </div>
  );
}
